/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Height_HelpInputs */

const en_options_display_height_help = /** @type {(inputs: Options_Display_Height_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of lines down the screen (1-50)`)
};

const fr_options_display_height_help = /** @type {(inputs: Options_Display_Height_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de lignes sur l'écran (1-50)`)
};

const de_options_display_height_help = /** @type {(inputs: Options_Display_Height_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Zeilen auf dem Bildschirm (1-50)`)
};

const it_options_display_height_help = /** @type {(inputs: Options_Display_Height_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di linee sullo schermo (1-50)`)
};

const ru_options_display_height_help = /** @type {(inputs: Options_Display_Height_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество строк на экране (от 1 до 50)`)
};

const es_options_display_height_help = /** @type {(inputs: Options_Display_Height_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de líneas en la pantalla (1-50)`)
};

const zh_cn2_options_display_height_help = /** @type {(inputs: Options_Display_Height_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`屏幕上方的行数（1-50）`)
};

const ja_options_display_height_help = /** @type {(inputs: Options_Display_Height_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面の行数（1～50）`)
};

const hi_options_display_height_help = /** @type {(inputs: Options_Display_Height_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्क्रीन पर नीचे की ओर जाने वाली पंक्तियों की संख्या (1-50)`)
};

const pt_pt2_options_display_height_help = /** @type {(inputs: Options_Display_Height_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de linhas na tela (1-50)`)
};

/**
* | output |
* | --- |
* | "Number of lines down the screen (1-50)" |
*
* @param {Options_Display_Height_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_height_help = /** @type {((inputs?: Options_Display_Height_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Height_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_height_help(inputs)
	if (locale === "de") return de_options_display_height_help(inputs)
	if (locale === "it") return it_options_display_height_help(inputs)
	if (locale === "ru") return ru_options_display_height_help(inputs)
	if (locale === "es") return es_options_display_height_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_height_help(inputs)
	if (locale === "ja") return ja_options_display_height_help(inputs)
	if (locale === "hi") return hi_options_display_height_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_height_help(inputs)
	return en_options_display_height_help(inputs)
});